import { useEffect, useState } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { connect } from 'react-redux';

import { STRIPE_KEY_FOR_TEST_UK } from './StripeHelper';
import { isProductionEnv, isSandboxEnv } from '../devOpsHelper/DevOps';

const mapStateToProps = ({ intl }) => ({
    ...intl
});

const IwStripeProvider = ({ children, language, stripeKey }) => {
    const [stripeObject, setStripeObject] = useState(null);

    useEffect(() => {
        const fetchStripeObject = async () => {
            if (stripeKey) {
                const res = await loadStripe(stripeKey);
                setStripeObject(res);
            }

            if (
                !stripeKey &&
                (!isProductionEnv() || isSandboxEnv()) &&
                !getCountry() === 'DE' //stripe is not enabled for DE
            ) {
                const res = await loadStripe(STRIPE_KEY_FOR_TEST_UK);
                setStripeObject(res);
            }
        };

        fetchStripeObject();
    }, [stripeKey]);

    return (
        //Elements support stripe passed in as null. Stripe is often null for DE.
        <Elements stripe={stripeObject} options={{ locale: language }}>
            {children}
        </Elements>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(IwStripeProvider);
